import { createBrowserRouter, Navigate } from 'react-router';
import UsagePage from '../pages/usage/UsagePage';
// 默认入口直接进入构建依赖图，让浏览器从 HTML 并行预加载图表依赖。
export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/usage" replace/> },
  { path: '/personas', lazy: async () => ({ Component: (await import('../pages/personas/PersonasPage')).default }) },
  { path: '/usage', Component: UsagePage },
  { path: '/conversation', lazy: async () => ({ Component: (await import('../pages/conversation/ConversationPage')).default }) },
  { path: '/conversation/language-errors', lazy: async () => ({ Component: (await import('../pages/conversation/LanguageErrorsPage')).default }) },
  { path: '/features', lazy: async () => ({ Component: (await import('../pages/features/FeatureUsagePage')).default }) },
  { path: '*', element: <main className="page"><h1>页面不存在</h1><a href="/usage">返回活跃与留存</a></main> },
]);
